import filter from 'lodash/filter'

import {
  ClanTask,
  GET_CLAN_TASKS,
  GET_CLAN_TASKS_RESPONSE,
  CLAIM_CLAN_TASK,
  CLAIM_CLAN_TASK_RESPONSE,
  CLAIM_CLAN_TASKS,
  CLAIM_CLAN_TASKS_RESPONSE, ClanTaskReward,
} from '~/Actions/ActionClanTasks'
import get from 'lodash/get'
import TaskRow from "~/Components/ViewClanTasks/TaskRow/TaskRow";

type Action = any

export type State = {
  isFetching: boolean,
  isClaiming: boolean,
  tasks: Array<ClanTask>,
  claimed: Array<ClanTask>,
  lastReward?: ClanTaskReward,
}

let initialState: State = {
  isFetching: false,
  isClaiming: false,
  tasks: get(window.__PRELOADED_STATE__, "clanTasks", []),
  claimed: [],
  lastReward: null,
}

export type IReducerClanTasks = (state: State, action: Action) => State
export const ReducerClanTasks = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case GET_CLAN_TASKS: {
      return { ...state, isFetching: true }
    }
    case GET_CLAN_TASKS_RESPONSE: {
      return { ...state, isFetching: false, isClaiming: false, tasks: action.payload }
    }
    case CLAIM_CLAN_TASK: {
      return { ...state, isClaiming: true }
    }
    case CLAIM_CLAN_TASK_RESPONSE: {
      let tasks = filter(state.tasks, (task: ClanTask) => task.name !== action.payload.name)
      tasks.push(action.payload)
      tasks = tasks.sort((a, b) => a.order > b.order ? 1 : -1)
      return { ...state, isClaiming: false, tasks }
    }
    case CLAIM_CLAN_TASKS: {
      return { ...state, isClaiming: true }
    }
    case CLAIM_CLAN_TASKS_RESPONSE: {
      const tasks = [...action.payload.unchanged, ...action.payload.changed].sort((a, b) => a.order > b.order ? 1 : -1)
      return { ...state, isClaiming: false, tasks, lastReward: action.payload.reward, claimed: action.payload.changed }
    }
    default:
      return state
  }
}
